import { C, NAV_ITEMS } from "../data/constants";
import { scrollTo } from "../hooks/useScrollFade";

export default function Footer() {
  return (
    <footer style={{ background: "#1A1715", padding: "clamp(36px,5vw,50px) clamp(16px,4vw,40px) 24px", textAlign: "center" }}>
      <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: "clamp(18px,2.5vw,22px)", color: C.linen, marginBottom: 6 }}>
        Moments & Milestones
      </h3>
      <p style={{ color: C.slate, fontSize: 12, marginBottom: 22 }}>Event Company · Cape Town, South Africa</p>
      <div style={{ display: "flex", justifyContent: "center", gap: "clamp(14px,2vw,28px)", flexWrap: "wrap", marginBottom: 22 }}>
        {NAV_ITEMS.map(n => (
          <button key={n} onClick={() => scrollTo(n.toLowerCase().replace(/ /g, "-"))}
            style={{ background: "none", border: "none", color: C.slate, cursor: "pointer", fontSize: "clamp(11px,1.2vw,13px)" }}>
            {n}
          </button>
        ))}
      </div>
      <div style={{ width: 44, height: 1, background: "rgba(159,172,157,0.22)", margin: "0 auto 16px" }} />
      <p style={{ color: "rgba(137,153,154,0.55)", fontSize: 11 }}>
        © {new Date().getFullYear()} Moments & Milestones · All rights reserved · Crafted with love in Cape Town
      </p>
    </footer>
  );
}